import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { CommonService } from 'src/app/core/services/common.service';
import { UserDto } from 'src/app/features/setup/models/userandrole/user.model';
import { GroupDto } from 'src/app/features/setup/models/userandrole/group.model';
import { ConsultNewActionDto } from '../../../models/add-new-action/consult-new-action.model';
import { AddNewActionService } from '../../../services/add-new-action.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-consult-assignment-popup',
  templateUrl: './consult-assignment-popup.component.html',
  styleUrls: ['./consult-assignment-popup.component.scss'],
    standalone: false
})
export class ConsultAssignmentPopupComponent implements OnInit {
  public consultAction: ConsultNewActionDto = { GroupId: -1 };
  public selectedGroup?: GroupDto;
  public selectedUserGroup?: UserDto;
  public groups: GroupDto[] = [];
  public groupUsers: UserDto[] = [];
  private abuName: string = 'ABU';
  isGoupSelected: boolean = false;
  consultComment: string = '';

  userGroupSelectDisabled: boolean = true;

  public groupSelectPlaceHolder: GroupDto = {
    name: 'Select group...',
    id: -1,
    description: undefined,
    businessunitId: undefined,
    groupTypeId: undefined,
    displayOrder: undefined,
    businessunitName: undefined,
    groupTypeName: undefined,
    isActive: undefined,
    createdBy: undefined,
    createdDateTime: undefined,
    modifiedBy: undefined,
    modifiedDateTime: undefined,
  };

  public userGroupSelectPlaceHolder: UserDto = {
    name: 'Select user group...',
    id: -1,
    provisionId: undefined,
    email: undefined,
    //cai: undefined, /* Commentted for 7136137: CAI Deprecation */
    objectId: undefined,
    userName: undefined,
    externalId: undefined,
    businessUnitId: undefined,
    groupIds: undefined,
    roleIds: undefined,
    roleDtos: undefined,
    groupDtos: undefined,
    businessUnitname: undefined,
  };

  constructor(
    public dialog: DialogRef,
    public commonService: CommonService,
    private addNewActionService: AddNewActionService
  ) {}

  ngOnInit(): void {
    this.getConsultItems();
  }

  getConsultItems() {
    const getGroups$ = this.addNewActionService.getGroups();
    forkJoin([getGroups$]).subscribe(([groups]) => {
      this.groups = groups.filter((x) => {
        if (x.businessunitName === this.abuName) {
          return true;
        }
      });
      this.userGroupSelectDisabled = true;
    });
  }

  public groupSelectionChange(value: GroupDto): void {
    if (value != undefined && value.id != -1) {
      this.isGoupSelected = true;
      this.selectedGroup = value;
      this.addNewActionService.getUserGroups(value.id).subscribe((result) => {
        this.groupUsers = result;
        this.userGroupSelectDisabled = false;
      });
    } else {
      this.isGoupSelected = false;
    }
  }

  public userGroupSelectionChange(value: UserDto): void {
    if (value != undefined) {
      this.selectedUserGroup = value;
    }
  }

  close(actionName: string): void {
    if (actionName === 'submit') {
      this.consultAction.GroupId = this.selectedGroup!.id;
      this.consultAction.UserGroupId = this.selectedUserGroup?.id;
      this.dialog.close({
        actionType: actionName,
        comment: this.consultComment,
        lineItemDtail: this.consultAction
      });
    } else {
      this.dialog.close({ actionType: actionName, consulttemDtail: {} });
    }
  }
}
